function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Controller } from 'stimulus';

var ThrottleController =
/*#__PURE__*/
function (_Controller) {
  _inherits(ThrottleController, _Controller);

  function ThrottleController() {
    _classCallCheck(this, ThrottleController);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThrottleController).apply(this, arguments));
  }

  return ThrottleController;
}(Controller);

ThrottleController.throttles = [];
var defaultWait = 200;
export function throttle(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWait;
  var inThrottle;
  return function () {
    var args = arguments;
    var context = this;

    if (!inThrottle) {
      inThrottle = true;
      func.apply(context, args);
      setTimeout(function () {
        return inThrottle = false;
      }, wait);
    }
  };
}
export var useThrottle = function useThrottle(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a;

  var constructor = controller.constructor;
  (_a = constructor.throttles) === null || _a === void 0 ? void 0 : _a.forEach(function (func) {
    if (typeof func === 'string') {
      ;
      controller[func] = throttle(controller[func], options === null || options === void 0 ? void 0 : options.wait);
    }

    if (_typeof(func) === 'object') {
      var name = func.name,
          wait = func.wait;
      if (!name) return;
      controller[name] = throttle(controller[name], wait || (options === null || options === void 0 ? void 0 : options.wait));
    }
  });
};